/**
 * Push notifications (screen 30 registers a token via `/notifications`).
 * Web uses the Notification API; Capacitor will register with FCM.
 */
export interface PushApi {
  isSupported(): boolean
  getPermission(): NotificationPermission | 'unsupported'
  requestPermission(): Promise<NotificationPermission | 'unsupported'>
  /** The token the backend stores. Null until a real FCM/WebPush registration exists. */
  getToken(): Promise<string | null>
}

export const webPush: PushApi = {
  isSupported() {
    return typeof Notification !== 'undefined'
  },
  getPermission() {
    return typeof Notification === 'undefined' ? 'unsupported' : Notification.permission
  },
  async requestPermission() {
    if (typeof Notification === 'undefined') return 'unsupported'
    return Notification.requestPermission()
  },
  async getToken() {
    // Requires a service worker and VAPID keys, or FCM under Capacitor.
    return null
  },
}
